import {Component, Input, OnInit} from '@angular/core';
import {OrderMethod} from "../../../../common";
import {Constraint} from "../../../../common/models/menu";

@Component({
  selector: 'constraint-info',
  standalone: false,
  template: `
    <div class="alert alert-warning" *ngIf="method!='i'">
      <div class="row">
        <div class="col-auto">
            <i class="fa fa-clock"></i>
        </div>
        <div class="col">
            {{ constraint.label }}
        </div>
      </div>
    </div>
  `
})

export class ConstraintInfo {
  @Input() constraint: Constraint;
  @Input() method: OrderMethod;
}
